export class Assignment {
  id: string;
  positionId: string;
  type: number;
  inspectorId: string;
  title: string;
  agencyId: string;
  inspectorName: string;
  agencyName: string;
  inspEmail: string;
  inspPhone: string;
  inspAgency: string;
  isRequested: number;
  covid: number;
  onSite: number;
  covidRecord: string | null;
}
